import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import debounce from "lodash.debounce"; // lodash.debounce , It will Add delay to observer that can help stoping the flickerings
import Loading from "../Loadings/Loading";
import { Helmet } from "react-helmet-async";
// Styles Sheets CSS
import Styles from "../../assets/css/Pages/Home.module.css";
// Global Imports
import { useGlobalState } from "../../Functions/GlobalStates";

const Home = () => {
  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  // React Elements References Here //////////////////////////////////// ...............
  const absoluteBoxRef = useRef(false); // Ref for the absolute box
  const CheckPageStateRef = useRef(false); // Ref for the check Page

  // Dynamically require all Categories images in the specified folder
  const HomeSection2AllCateImages = require.context(
    "../../assets/images/HomeSection2Images",
    false,
    /\.(png|jpe?g|webp|gif|avif)$/ // Match png, jpg, jpeg, webp, and gif extensions
  );
  // Dynamically require all flag images in the specified folder
  const HomeSection3BackgroundImages = require.context(
    "../../assets/images/HomeSection3Images/Backgrounds",
    false,
    /\.(png|jpe?g|webp|gif|avif)$/ // Match png, jpg, jpeg, webp, and gif extensions
  );
  const HomeSection3Images = require.context(
    "../../assets/images/HomeSection3Images/Images",
    false,
    /\.(png|jpe?g|webp|gif|avif)$/ // Match png, jpg, jpeg, webp, and gif extensions
  );

  // updating height to modify Navbar DropMenu height
  useEffect(() => {
    const updateSize = debounce(() => {
      if (absoluteBoxRef.current) {
        const { width, height } =
          absoluteBoxRef.current.getBoundingClientRect();
        setPagesWidthHeight((prev) => ({
          ...prev,
          height: parseFloat(height.toFixed(1)),
        }));
      }
      // console.log("running function");
    }, 100);

    updateSize(); // Run once on mount
    const scrolleventwait = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", scrolleventwait);
    // console.log("running");

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", scrolleventwait);
      // console.log("running return");
    };
  }, [IsLoaded]); // Empty dependency array to run only on mount and unmount

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  // Dynamically require all images in the specified folder.
  const HomeSection2AllCate = [
    HomeSection2AllCateImages("./1.avif"),
    HomeSection2AllCateImages("./2.avif"),
    HomeSection2AllCateImages("./3.avif"),
    HomeSection2AllCateImages("./4.avif"),
  ];

  const Section3Images = [HomeSection3Images("./EarthHandshake.png")];

  const Section3BackgroundImages = [
    HomeSection3BackgroundImages("./StarsShades1colorred.avif"),
    HomeSection3BackgroundImages("./StarsShades2colorpurple.avif"),
    HomeSection3BackgroundImages("./StarsShades3colorgreen.avif"),
    HomeSection3BackgroundImages("./StarsShades5colororange.avif"),
    HomeSection3BackgroundImages("./StarsShades4colorpink.avif"),
    HomeSection3BackgroundImages("./StarsShades6colorblue.avif"),
  ];

  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([HomeSection2AllCate[0]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(
        (prevIndex) => (prevIndex + 1) % Section3BackgroundImages.length
      );
      // console.log("Car animation image changed");
    }, 1000); // For car animation background image

    return () => clearInterval(interval); // Clean up the interval on unmount
  }, []); // Runs only once when component mounts

  // For Color Of Text To Change Periodically Use This
  const ChangeColorsPeriodically = [
    "red",
    "purple",
    "lightgreen",
    "orange",
    "pink",
    "cyan",
  ];

  return IsLoaded ? (
    <>
      <Helmet>
        {/* Title: Displayed in browser tabs and search results */}
        <title>Affiliators Informational Blogs - Gift Guides & More</title>

        {/* Meta Description: Helps with SEO and search engine ranking */}
        <meta
          name="description"
          content="Discover expert informational blogs with gift guides, shopping tips, and curated recommendations to help you choose the perfect presents for any occasion."
        />

        {/* Meta Keywords: Use sparingly and focus on relevance */}
        <meta
          name="keywords"
          content="informational blogs, gift guides, best gifts, present ideas, shopping tips, expert recommendations"
        />

        {/* Viewport for mobile responsiveness */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Tags for Social Media Optimization */}
        <meta
          property="og:title"
          content="Affiliators Informational Blogs - Gift Guides & More"
        />
        <meta
          property="og:description"
          content="Explore our blog for expert gift guides, shopping insights, and recommendations!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://affiliators.netlify.app/#/" />
        
        {/* <meta
          property="og:image"
          content="https://affiliators.netlify.app/images/blogs.jpg"
        /> 
        
        <meta
          name="twitter:image"
          content="https://affiliators.netlify.app/images/blogs.jpg"
        /> */}

        {/* Twitter Card for Social Media Preview */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Affiliators Informational Blogs - Gift Guides & More"
        />
        <meta
          name="twitter:description"
          content="Explore our blog for expert gift guides, shopping insights, and recommendations!"
        />

        {/* Canonical URL to prevent duplicate content issues */}
        {/* <link rel="canonical" href="https://affiliators.netlify.app/#/" /> */}

        {/* Robots: Ensure indexing and following of links */}
        <meta name="robots" content="index, follow" />

        {/* Language settings */}
        <meta name="language" content="en" />
        <meta httpEquiv="Content-Language" content="en" />

        {/* Author for credibility */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
      </Helmet>

      <div ref={absoluteBoxRef} className={Styles.HomeContainer}>
        <section className={Styles.HomeSection1Container}>
          <div className={Styles.HomeSection1ImgContactContainer}></div>
        </section>
        <section className={Styles.HomeSection2Container}>
          <section className={Styles.HomeSection2}>
            <NavLink to="/problemsolving/npmerrors">
              <div className={Styles.HomeSection2HeadingImg1Container}>
                <h1>PROBLEM SOLVING</h1>
                <img src={HomeSection2AllCate[0]} alt="PROBLEM SOLVING Blogs" />
              </div>
            </NavLink>
            <NavLink to="/reallifegadgets/rechargeablespotlight">
              <div className={Styles.HomeSection2HeadingImg2Container}>
                <h1>REALLIFE GADGETS</h1>
                <img
                  src={HomeSection2AllCate[1]}
                  alt="REALLIFE GADGETS Blogs"
                />
              </div>
            </NavLink>
            <NavLink to="/PerfectGiftsGuide/goldplatedflower">
              <div className={Styles.HomeSection2HeadingImg3Container}>
                <h1>PERFECT GIFTS GUIDE</h1>
                <img
                  src={HomeSection2AllCate[2]}
                  alt="PERFECT GIFTS GUIDE Blogs"
                />
              </div>
            </NavLink>
            <NavLink to="/">
              <div className={Styles.HomeSection2HeadingImg4Container}>
                <h1>INFORMATIONAL TOPICS</h1>
                <img
                  src={HomeSection2AllCate[3]}
                  alt="INFORMATIONAL TOPICS Blogs"
                />
              </div>
            </NavLink>
          </section>
        </section>

        <section
          className={Styles.HomeSection3Container} // Trigger animation class when in view
          style={{
            backgroundImage: `url(${Section3BackgroundImages[currentImageIndex]})`,
          }}
        >
          <div className={Styles.HomeSection3H1Container}>
            <h1>WHY BLOGS</h1>
          </div>
          <div className={Styles.HomeSection3TextImagesContainer}>
            <p className={Styles.HomeSection3WHyTextAnswer}>
              Blogs are a way to share solutions and guidance, helping people
              everywhere with useful insights.😘✨
            </p>
            <img src={Section3Images[0]} alt="Images Loading" />
          </div>
        </section>
      </div>
    </>
  ) : (
    <Loading />
  );
};

export default Home;
